export const getCurrentUrl = (): string => {
    return window?.location.href ?? global.current_url;
};

export const updateQueryStringParam = (key, value, uri = undefined) => {
    if (!uri) {
        uri = getCurrentUrl();
    }
    let re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    let separator = uri.indexOf("?") !== -1 ? "&" : "?";
    if (uri.match(re)) {
        return uri.replace(re, "$1" + key + "=" + value + "$2");
    } else {
        return uri + separator + key + "=" + value;
    }
};

export const getParam = (param, uri = undefined) => {
    if (!uri) {
        uri = getCurrentUrl();
    }

    const indexOfHash = uri?.indexOf("#");
    const substringEnd = indexOfHash === -1 ? uri?.length : indexOfHash;
    uri = uri?.substr(0, substringEnd)?.split("?");
    if (!uri?.[1]) {
        return "";
    }
    uri = uri[1];
    //return tmp.utils.url().searchParams.get(param);
    let vars = uri.split("&");
    for (let i = 0; i < vars.length; i++) {
        let pair = vars[i].split("=");
        if (pair[0] == param) {
            return pair[1];
        }
    }
    return "";
};

export const updateUrlQueryStringParam = (key, value, uri = undefined) => {
    if (!uri) {
        uri = getCurrentUrl();
    }

    if (Array.isArray(key)) {
        jQuery?.each(key, (key1, value1) => {
            uri = updateQueryStringParam(key1, value1, uri);
        });
    } else {
        uri = updateQueryStringParam(key, value, uri);
    }

    return window.history.replaceState(null, document.title, uri);
};

export const pushUpdateUrlQueryStringParam = (key, value = undefined, uri = undefined) => {
    if (!uri) {
        uri = getCurrentUrl();
    }

    if (typeof key === "object" && key !== null) {
        jQuery?.each(key, (key1, value1) => {
            uri = updateQueryStringParam(key1, value1, uri);
        });
    } else {
        uri = updateQueryStringParam(key, value, uri);
    }

    return window.history.pushState(null, document.title, uri);
};

export const removeQueryStringParam = (parameter, uri = undefined) => {
    if (!uri) {
        uri = getCurrentUrl();
    }
    let urlparts = uri.split("?");
    if (urlparts.length >= 2) {
        let prefix = encodeURIComponent(parameter) + "=";
        let pars = urlparts[1].split(/[&;]/g);

        for (var i = pars.length; i-- > 0; ) {
            if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                pars.splice(i, 1);
            }
        }

        return window.history.replaceState(
            null,
            document.title,
            urlparts[0] + (pars.length > 0 ? "?" + pars.join("&") : "")
        );
    }
    return window.history.replaceState(null, document.title, uri);
};

export const pushRemoveQueryStringParam = (parameter, uri = undefined) => {
    if (!uri) {
        uri = getCurrentUrl();
    }
    let urlparts = uri.split("?");
    if (urlparts.length >= 2) {
        let prefix = encodeURIComponent(parameter) + "=";
        let pars = urlparts[1].split(/[&;]/g);

        for (var i = pars.length; i-- > 0; ) {
            if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                pars.splice(i, 1);
            }
        }

        return window.history.pushState(
            null,
            document.title,
            urlparts[0] + (pars.length > 0 ? "?" + pars.join("&") : "")
        );
    }
    return window.history.pushState(null, document.title, uri);
};
